import React from "react";
import {
  SummarySection,
  SectionHeading,
  SectionBox,
  EmptyStateMessage,
} from "./InfoSection.styles";

export const InfoSection = ({ title, content, emptyMessage }) => (
  <SummarySection>
    <SectionHeading>{title}</SectionHeading>
    <SectionBox>
      {!content ? (
        <EmptyStateMessage>{emptyMessage}</EmptyStateMessage>
      ) : (
        content
      )}
    </SectionBox>
  </SummarySection>
);
